import { useState } from "react"
import { studentRequest } from "services/requests"

const prefix = "rewards"
const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getSections = async ({ groupId, typeId = 0 }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/sections?groupId=${groupId}&typeId=${typeId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || []
  }

  const getCategory = async ({
    groupId,
    recognitionCategoryId,
    sectionTypeId = 0,
  }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/category?groupId=${groupId}&categoryId=${recognitionCategoryId}&sectionTypeId=${sectionTypeId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || []
  }

  const getReward = async ({ groupId, itemId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/reward?groupId=${groupId}&itemId=${itemId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || {}
  }

  const getRewardByAssignations = async ({ userItemId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/reward/${userItemId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || {}
  }

  const getCurriculumReward = async ({ groupId, curriculumId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/curriculum?groupId=${groupId}&curriculumId=${curriculumId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || {}
  }

  const getUnreadRewards = async ({ languageId = null }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/reward/unread?learningLanguageId=${languageId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || []
  }

  const setRewardRead = async ({ userItemId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/reward/read/${userItemId}`,
      body: null,
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || {}
  }

  return {
    getSections,
    getCategory,
    getReward,
    getCurriculumReward,
    getRewardByAssignations,
    getUnreadRewards,
    setRewardRead,
    isFetching,
  }
}

export default useApi
